import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Images } from "../../helper/images";

const Objectives = () => {

    const render = () => {
        return (
            <>
                <h3 className="text-blue h4 mb-5 mb-0">Objective</h3>
                <p>Most businesses aren’t failing at AI—they haven’t even started right.<br />
                    Despite the hype, AI adoption remains painfully slow and scattered, especially among small and medium-sized enterprises. It’s not because of lack of ambition, but due to a maze of barriers:
                </p>
                <h4 className="text-blue mb-4 mb-0">The Current State of AI Adoption</h4>
                <div className="text-dark mb-2"><strong>Complexity & Misconception</strong></div>
                <ul className="ml-3 mb-3 list-style-disc">
                    <li>Businesses often confuse casual AI tools (like ChatGPT) with actual transformation.</li>
                    <li>Most lack the know-how to connect AI to real business value.</li>
                </ul>
                <div className="text-dark mb-2"><strong>Fragmented Ecosystem</strong></div>
                <ul className="ml-3 mb-4 list-style-disc">
                    <li>Strategy, training, implementation, and support are sold separately — leading to confusion, delays, and failed pilots.</li>
                </ul>
                <h4 className=" text-blue mb-4 mt-3 mb-0">Why We Created “AI Navigator”</h4>
                <div className="text-dark mb-2"><strong>To simplify AI, make it strategic, and make it yours.</strong></div>
                <ul className="ml-3 mb-3 list-style-disc">
                    <li>Diagnose your current maturity level — without jargon or tech overload.</li>
                    <li>Discover the gaps between where you are and where you could be.</li>
                    <li>Visualize business-aligned use cases, not generic AI buzzwords.</li>
                    <li>Plan a scalable path forward — backed by ROI, execution readiness, and support.</li>
                </ul>
                <div className="d-flex flex-column align-items-center gap-2 p-4 border border-1 mt-5 mb-3">
                    <img src={Images.journey} alt="AI Navigator Journey" className="img-fluid my-4" />
                </div>
                <NavigationButton name={'Next'} url={'/company-intro'} />
            </>
        )
    }

    return render()
};

export default Objectives;

export const NavigationButton = ({ name, url, noArrow = false }) => {
    return (
        <div className="row d-flex justify-content-center">
            <div className="col-sm-2">
                <Link
                    to={url}
                    className={`btn1 arrowhover d-flex align-items-center justify-content-center font-weight-bold text-center gap-2`}
                >
                    <div>{name}</div>
                    {!noArrow && <div className="span">
                        <svg
                            width="25"
                            height="24"
                            viewBox="0 0 45 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M44.0607 13.0607C44.6464 12.4749 44.6464 11.5251 44.0607 10.9393L34.5147 1.3934C33.9289 0.807612 32.9792 0.807612 32.3934 1.3934C31.8076 1.97918 31.8076 2.92893 32.3934 3.51472L40.8787 12L32.3934 20.4853C31.8076 21.0711 31.8076 22.0208 32.3934 22.6066C32.9792 23.1924 33.9289 23.1924 34.5147 22.6066L44.0607 13.0607ZM0 13.5H43V10.5H0V13.5Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                    }
                </Link>
            </div>
        </div>
    )
}